import { messagesByLocale } from "./messages";
import type { AppLocale, MessageKey } from "./types";

export function translate(
  locale: AppLocale,
  key: MessageKey,
  vars?: Record<string, string>,
): string {
  const template =
    messagesByLocale[locale][key] ?? messagesByLocale.ru[key] ?? key;
  if (!vars) {
    return template;
  }
  return Object.entries(vars).reduce((result, [name, value]) => {
    const placeholder = `{{${name}}}`;
    return result.split(placeholder).join(value);
  }, template);
}
